import { useState } from 'react';
import { C } from '../constants';
import { Btn, Card } from './Atoms';
import LOGO from '../assets/logo';

// ─── LEGAL PAGES ───────────────────────────────────────────
function LegalPage({ titulo, onBack, children }) {
  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <div style={{ background: C.white, borderBottom: `1px solid ${C.gray200}`, padding: '0 16px', height: 56, display: 'flex', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', color: C.primary, fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", display: 'flex', alignItems: 'center', gap: 4 }}>← Volver</button>
        <div style={{ flex: 1, textAlign: 'center', fontSize: 14, fontWeight: 800, color: C.text, marginRight: 50 }}>{titulo}</div>
      </div>
      <div style={{ padding: '24px 20px 60px', maxWidth: 480, margin: '0 auto' }}>{children}</div>
    </div>
  );
}
function LH1({ children }) { return <div style={{ fontSize: 20, fontWeight: 900, color: C.primary, marginBottom: 6, marginTop: 8 }}>{children}</div>; }
function LH2({ children }) { return <div style={{ fontSize: 15, fontWeight: 800, color: C.text, marginTop: 24, marginBottom: 8 }}>{children}</div>; }
function LP({ children }) { return <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.8, marginBottom: 10 }}>{children}</div>; }
function LB({ children }) { return <div style={{ display: 'flex', gap: 8, marginBottom: 6 }}><div style={{ color: C.primary, fontWeight: 900, flexShrink: 0 }}>•</div><div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.7 }}>{children}</div></div>; }
function LHr() { return <div style={{ borderBottom: `1px solid ${C.gray200}`, margin: '20px 0' }} />; }

function AvisoPrivacidad({ onBack }) {
  return (
    <LegalPage titulo="Aviso de Privacidad" onBack={onBack}>
      <LH1>Aviso de Privacidad</LH1>
      <LP>Última actualización: 13 de marzo de 2026</LP><LHr />
      <LH2>1. Responsable</LH2>
      <LP>TandaClick SOFOM E.N.R., León, Guanajuato. Contacto: privacidad@tandaclick.com</LP><LHr />
      <LH2>2. Datos que recopilamos</LH2>
      <LB>Nombre, email, teléfono, contraseña</LB>
      <LB>CURP, INE frente/reverso, selfie (al ingresar a una tanda)</LB>
      <LB>Dirección completa (al ingresar a una tanda)</LB>
      <LB>CLABE interbancaria y nombre del titular</LB>
      <LB>Referencia personal (nombre y teléfono)</LB>
      <LB>Historial de pagos y score de confianza interno</LB><LHr />
      <LH2>3. Finalidades</LH2>
      <LB>Registro, autenticación y operación de tandas</LB>
      <LB>Verificación de identidad y prevención de fraudes</LB>
      <LB>Notificaciones y recordatorios vía WhatsApp</LB>
      <LB>Reporte al Buró de Crédito (positivo y negativo)</LB>
      <LB>Cumplimiento de obligaciones como SOFOM E.N.R.</LB><LHr />
      <LH2>4. Buró de Crédito</LH2>
      <div style={{ background: C.dangerLt, border: '1px solid #FECACA', borderRadius: 12, padding: '12px 14px', marginBottom: 12 }}>
        <LP>⚠️ TandaClick reporta tu comportamiento de pago al Buró de Crédito. Pagos puntuales suman positivamente. Pagos tardíos o incumplidos se reportan negativamente.</LP>
      </div><LHr />
      <LH2>5. Transferencia de datos</LH2>
      <LB>TandaClick SOFOM E.N.R. — evaluación crediticia</LB>
      <LB>Buró de Crédito — reporte de comportamiento</LB>
      <LB>Twilio Inc. — mensajes WhatsApp</LB>
      <LB>Supabase Inc. — infraestructura y almacenamiento</LB><LHr />
      <LH2>6. Derechos ARCO</LH2>
      <LP>Envía un correo a privacidad@tandaclick.com con asunto "Derechos ARCO" adjuntando identificación oficial. Respondemos en máximo 20 días hábiles.</LP>
    </LegalPage>
  );
}

function TerminosCondiciones({ onBack }) {
  return (
    <LegalPage titulo="Términos y Condiciones" onBack={onBack}>
      <LH1>Términos y Condiciones</LH1>
      <LP>Última actualización: 13 de marzo de 2026</LP>
      <LP>Al registrarte en TandaClick aceptas íntegramente estos Términos.</LP><LHr />
      <LH2>1. Requisitos</LH2>
      <LB>Ser persona física mayor de 18 años residente en México</LB>
      <LB>Proporcionar información veraz y mantenerla actualizada</LB><LHr />
      <LH2>2. Tandas</LH2>
      <LB>Los pagos se realizan por transferencia SPEI o OXXO (próximamente)</LB>
      <LB>Debes subir comprobante de pago en la app</LB>
      <LB>El organizador confirma pagos en máximo 24 horas hábiles</LB><LHr />
      <LH2>3. Niveles y adelanto</LH2>
      <LB>Bronce: sin adelanto | Plata: 12% | Oro: 10% | Platino: 8%</LB>
      <LB>Acceso a crédito TandaClick SOFOM E.N.R. desde nivel Oro</LB><LHr />
      <LH2>4. Buró de Crédito</LH2>
      <div style={{ background: C.dangerLt, border: '1px solid #FECACA', borderRadius: 12, padding: '12px 14px', marginBottom: 12 }}>
        <LP>⚠️ Aceptas que TandaClick reporte tu comportamiento de pago al Buró de Crédito, positiva o negativamente según corresponda.</LP>
      </div><LHr />
      <LH2>5. Obligaciones</LH2>
      <LB>Pagar en los plazos establecidos</LB>
      <LB>No compartir tu cuenta con terceros</LB>
      <LB>No usar la plataforma para fines ilícitos</LB><LHr />
      <LH2>6. Jurisdicción</LH2>
      <LP>Rigen las leyes de México. Jurisdicción: León, Guanajuato.</LP>
      <LP>Contacto: privacidad@tandaclick.com</LP>
    </LegalPage>
  );
}

// ─── MODAL INSTALAR PWA ────────────────────────────────────
function ModalInstalar({ onClose }) {
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isAndroid = /android/i.test(navigator.userAgent);
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: C.white, borderRadius: '20px 20px 0 0', padding: '24px 20px 40px', width: '100%', maxWidth: 480 }}>
        <div style={{ width: 40, height: 4, background: C.gray200, borderRadius: 99, margin: '0 auto 20px' }} />
        <div style={{ fontSize: 20, fontWeight: 900, color: C.text, marginBottom: 4, textAlign: 'center' }}>📲 Instala TandaClick</div>
        <div style={{ fontSize: 13, color: C.textMd, textAlign: 'center', marginBottom: 24 }}>Agrégala a tu pantalla de inicio para acceder como app.</div>
        {isIOS ? (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 10 }}>iPhone / iPad (Safari)</div>
            {[['⬆️', 'Toca el ícono de compartir'], ['⬇️', 'Baja y toca "Agregar a Inicio"'], ['✅', 'Asegúrate que "Abrir como app web" esté activado'], ['👆', 'Toca "Agregar"']].map(([icon, t], i) => (
              <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 8, alignItems: 'center' }}>
                <div style={{ width: 24, height: 24, borderRadius: '50%', background: C.primary, color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900, flexShrink: 0 }}>{i + 1}</div>
                <span style={{ fontSize: 12 }}>{icon} {t}</span>
              </div>
            ))}
          </div>
        ) : isAndroid ? (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 10 }}>Android (Chrome)</div>
            {[['📲', 'Toca "Instalar" en el banner que aparece'], ['⋮', 'O toca los tres puntos arriba a la derecha'], ['➕', 'Selecciona "Agregar a pantalla de inicio"']].map(([icon, t], i) => (
              <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 8, alignItems: 'center' }}>
                <div style={{ width: 24, height: 24, borderRadius: '50%', background: C.primary, color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900, flexShrink: 0 }}>{i + 1}</div>
                <span style={{ fontSize: 12 }}>{icon} {t}</span>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ marginBottom: 16, fontSize: 12, color: C.textMd }}>
            Abre esta página en el navegador de tu celular y agrégala a la pantalla de inicio.
          </div>
        )}
        <Btn onClick={onClose}>Entendido</Btn>
      </div>
    </div>
  );
}

// ─── FAQ ────────────────────────────────────────────────────
function FaqLista() {
  const [abierto, setAbierto] = useState(null);
  const [verMas, setVerMas] = useState(false);
  const faqs = [
    {
      q: '¿Qué es una tanda?',
      a: 'Una tanda es un sistema de ahorro grupal donde cada miembro aporta una cantidad fija cada semana. Cada semana un integrante diferente recibe el total acumulado del grupo. Al final, todos reciben su dinero sin cobros de intereses.',
    },
    {
      q: '¿Cómo sé que puedo confiar en los demás participantes?',
      a: 'Cada miembro tiene un score público y un nivel (Bronce, Plata, Oro, Platino) basado en su historial real de tandas completadas y pagos a tiempo. Si entras a una tanda con personas Platino, sabes que ya demostraron ser confiables múltiples veces.',
    },
    {
      q: '¿Puedo ver el historial de otros participantes antes de unirme?',
      a: 'Sí. Antes de confirmar tu lugar en una tanda puedes ver el nivel, score, número de tandas completadas y número de retrasos de cada participante. Nada de información personal — solo su historial de confianza.',
    },
    {
      q: '¿Qué pasa si alguien no paga su semana?',
      a: 'TandaClick monitorea cada pago. Si un participante no sube su comprobante a tiempo, el sistema lo marca con retraso — lo que baja su score permanentemente. En casos graves, el admin puede suspender al participante de la tanda.',
    },
    {
      q: '¿Para qué sirven los niveles Bronce, Plata, Oro y Platino?',
      a: 'Los niveles muestran tu historial de confianza. A mayor nivel, puedes entrar a tandas de montos más altos y con participantes más confiables. También desbloqueas adelantos de tu tanda a menores comisiones: Plata 12%, Oro 10% y Platino solo 8%.',
    },
    {
      q: '¿Qué es un adelanto de tanda?',
      a: 'Si necesitas tu dinero antes de que te toque cobrar, TandaClick (a través de nuestra alianza con TandaClick SOFOM E.N.R.) puede adelantarte el monto de tu tanda. Pagas una comisión según tu nivel y recuperas tu lugar normal en la tanda.',
    },
    {
      q: '¿Cómo funciona el pago?',
      a: 'Cada semana depositas tu aportación por SPEI a la CLABE de tu tanda. Subes el comprobante en la app y el admin lo confirma. Cuando te toque cobrar, recibes la tanda completa en tu cuenta bancaria o CLABE registrada.',
    },
    {
      q: '¿TandaClick cobra comisión?',
      a: 'TandaClick cobra una comisión del 3% al momento de entregarte tu tanda. Si solicitas un adelanto antes de tu turno, pagas una comisión adicional según tu nivel. No hay más cobros ocultos.',
    },
    {
      q: '¿Mis datos están seguros?',
      a: 'Sí. Usamos encriptación de extremo a extremo y seguimos las mejores prácticas de la industria financiera. Tu CLABE y datos personales nunca son visibles para otros participantes — solo el equipo de TandaClick tiene acceso a esa información para confirmar pagos.',
    },
    {
      q: '¿Necesito una cuenta bancaria para participar?',
      a: 'No es necesario. Puedes depositar por transferencia SPEI desde cualquier banco o en efectivo en cualquier OXXO. Para cobrar, puedes recibir por transferencia a tu CLABE bancaria o con un código QR en OXXO si prefieres efectivo.',
    },
  ];

  const faqsVisibles = verMas ? faqs : faqs.slice(0, 4);

  return (
    <div>
      {faqsVisibles.map((faq, i) => (
        <div key={i} style={{ border: `1.5px solid ${abierto === i ? '#1A56DB' : '#E5E7EB'}`, borderRadius: 14, marginBottom: 10, overflow: 'hidden', transition: 'border-color 0.2s', background: '#fff' }}>
          <button
            onClick={() => setAbierto(abierto === i ? null : i)}
            style={{ width: '100%', background: 'none', border: 'none', padding: '16px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", textAlign: 'left' }}>
            <span style={{ fontSize: 14, fontWeight: 800, color: '#1E293B', lineHeight: 1.4 }}>{faq.q}</span>
            <span style={{ fontSize: 18, color: abierto === i ? '#1A56DB' : '#9CA3AF', flexShrink: 0, transition: 'transform 0.2s', transform: abierto === i ? 'rotate(45deg)' : 'none' }}>+</span>
          </button>
          {abierto === i && (
            <div style={{ padding: '0 18px 18px', fontSize: 14, color: '#475569', lineHeight: 1.8 }}>
              {faq.a}
            </div>
          )}
        </div>
      ))}
      {!verMas && (
        <button onClick={() => setVerMas(true)} style={{ width: '100%', padding: '14px', background: 'none', border: `1.5px solid #1A56DB`, borderRadius: 14, color: '#1A56DB', fontSize: 14, fontWeight: 800, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif", marginTop: 4 }}>
          Ver más preguntas ({faqs.length - 4})
        </button>
      )}
    </div>
  );
}

// ─── LANDING PAGE ───────────────────────────────────────────

// ─── TABLA NIVELES ─────────────────────────────────────────────
function TablaNiveles() {
  const nivData = [
    { icon: '🥉', nivel: 'Bronce', pts: '0-19 pts', color: '#92400E', bg: '#FEF3C7', aport: '$500',    dep: true,  org: false, adelanto: null,  credito: false },
    { icon: '🥈', nivel: 'Plata',  pts: '20+ pts', color: '#374151', bg: '#F3F4F6', aport: '$2,000',  dep: false, org: false, adelanto: '12%', credito: false },
    { icon: '🥇', nivel: 'Oro',    pts: '50+ pts', color: '#854D0E', bg: '#FEF9C3', aport: '$5,000',  dep: false, org: true,  adelanto: '10%', credito: true  },
    { icon: '💎', nivel: 'Platino',pts: '80+ pts', color: '#1E40AF', bg: '#DBEAFE', aport: 'Sin limite',  dep: false, org: true,  adelanto: '8%',  credito: true  },
  ];
  const Check = () => (
    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, borderRadius: '50%', background: '#D1FAE5' }}>
      <svg width="10" height="10" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
    </span>
  );
  const Dash = () => <span style={{ display: 'inline-block', width: 18, height: 18, lineHeight: '18px', color: '#CBD5E1', fontSize: 14 }}>–</span>;
  const thStyle = { padding: '8px 4px', textAlign: 'center', borderBottom: `2px solid ${C.gray200}`, fontSize: 11 };
  const tdStyle = (alt) => ({ padding: '8px 4px', textAlign: 'center', borderBottom: `1px solid ${C.gray200}`, fontSize: 11, background: alt ? C.gray50 : C.white });
  const tdFirst = (alt) => ({ ...tdStyle(alt), textAlign: 'left', paddingLeft: 8, fontWeight: 600, color: C.textMd, fontSize: 11 });
  const secStyle = { fontSize: 9, fontWeight: 700, color: C.textLt, letterSpacing: '0.08em', textTransform: 'uppercase', padding: '10px 8px 4px', background: C.gray100, textAlign: 'left' };
  return (
    <div>
      <div style={{ fontSize: 12, fontWeight: 800, color: C.primary, letterSpacing: 1, textAlign: 'center', marginBottom: 8, textTransform: 'uppercase' }}>Sistema de niveles</div>
      <h2 style={{ fontSize: 24, fontWeight: 800, color: C.text, textAlign: 'center', marginBottom: 4 }}>Tu historial vale oro</h2>
      <p style={{ fontSize: 13, color: C.textMd, textAlign: 'center', marginBottom: 20 }}>Sube de nivel pagando a tiempo</p>
      <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: 14, overflow: 'hidden', border: `1px solid ${C.gray200}`, background: C.white, tableLayout: 'fixed' }}>
        <thead>
          <tr>
            <th style={{ ...thStyle, textAlign: 'left', paddingLeft: 8, width: '28%' }}></th>
            {nivData.map(n => (
              <th key={n.nivel} style={thStyle}>
                <div style={{ fontSize: 16, lineHeight: 1.2 }}>{n.icon}</div>
                <span style={{ fontSize: 9, fontWeight: 700, color: n.color, background: n.bg, padding: '1px 5px', borderRadius: 99, marginTop: 2, display: 'inline-block' }}>{n.nivel}</span>
                <div style={{ fontSize: 8, color: '#94A3B8', marginTop: 2 }}>{n.pts}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr><td colSpan={5} style={secStyle}>Beneficios</td></tr>
          <tr>
            <td style={tdFirst(true)}>Aportación<br/><span style={{ fontSize: 9, fontWeight: 400, color: C.textLt }}>máximo</span></td>
            {nivData.map((n, i) => <td key={i} style={tdStyle(true)}><span style={{ fontSize: 10, fontWeight: 700, color: C.text }}>{n.aport}</span></td>)}
          </tr>
          <tr>
            <td style={tdFirst(false)}>Depósito de<br/>seguridad</td>
            {nivData.map((n, i) => (
              <td key={i} style={tdStyle(false)}>
                {n.dep
                  ? <span style={{ fontSize: 9, fontWeight: 700, color: '#DC2626', background: '#FEE2E2', padding: '2px 5px', borderRadius: 99 }}>Sí</span>
                  : <span style={{ fontSize: 9, fontWeight: 700, color: '#059669', background: '#D1FAE5', padding: '2px 5px', borderRadius: 99 }}>No</span>
                }
              </td>
            ))}
          </tr>
          <tr>
            <td style={tdFirst(true)}>Organizar tandas</td>
            {nivData.map((n, i) => <td key={i} style={tdStyle(true)}>{n.org ? <Check /> : <Dash />}</td>)}
          </tr>
          <tr>
            <td style={tdFirst(false)}>Adelanto de tanda<br/><span style={{ fontSize: 9, fontWeight: 400, color: C.textLt }}>(comisión)</span></td>
            {nivData.map((n, i) => (
              <td key={i} style={tdStyle(false)}>
                {n.adelanto ? <span style={{ fontSize: 10, fontWeight: 700, color: C.text }}>{n.adelanto}</span> : <Dash />}
              </td>
            ))}
          </tr>
          <tr>
            <td style={tdFirst(true)}>Crédito<br/>TandaClick</td>
            {nivData.map((n, i) => <td key={i} style={tdStyle(true)}>{n.credito ? <Check /> : <Dash />}</td>)}
          </tr>
        </tbody>
      </table>
      <div style={{ marginTop: 14, padding: '12px 14px', background: C.dangerLt, borderRadius: 12, border: '1px solid #FECACA' }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: C.danger, marginBottom: 3 }}>⚠️ Buró de Crédito</div>
        <div style={{ fontSize: 12, color: C.text, lineHeight: 1.6 }}>Los pagos puntuales <strong>suman a tu historial</strong>. Los tardíos se reportan negativamente.</div>
      </div>
    </div>
  );
}

function Landing({ onEntrar, showBanner, onDismissBanner, onAviso, onTerminos }) {
  const [modalInstalar, setModalInstalar] = useState(false);

  const niveles = [
    { nivel: 'Bronce', req: 'Tanda de bienvenida', label: 'Comienza tu historial', monto: '$200–$500', icon: '🥉' },
    { nivel: 'Plata', req: '20+ puntos (2 tandas completadas)', label: '12% comisión adelanto', monto: '$500–$2,000', icon: '🥈' },
    { nivel: 'Oro', req: '50+ puntos (5 tandas completadas)', label: '10% comisión adelanto', monto: '$2,000–$5,000', icon: '🥇' },
    { nivel: 'Platino', req: '80+ puntos', label: '8% comisión adelanto', monto: '$5,000+', icon: '💎' },
  ];

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: C.white }}>
      {modalInstalar && <ModalInstalar onClose={() => setModalInstalar(false)} />}

      {/* PWA Banner */}
      {showBanner && (
        <div style={{ background: `linear-gradient(90deg, ${C.primary}, ${C.accent})`, padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 10, position: 'sticky', top: 0, zIndex: 200 }}>
          <div style={{ fontSize: 20 }}>📲</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: C.white }}>Instala TandaClick en tu celular</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.8)' }}>Sin App Store · Funciona como app nativa</div>
          </div>
          <button onClick={() => setModalInstalar(true)} style={{ background: C.white, border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, fontWeight: 800, color: C.primary, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Instalar</button>
          <button onClick={onDismissBanner} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: 22, cursor: 'pointer', padding: '0 4px' }}>×</button>
        </div>
      )}

      {/* Navbar */}
      <nav style={{ background: C.white, borderBottom: `1px solid ${C.gray200}`, padding: '0 20px', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: showBanner ? 48 : 0, zIndex: 100, boxShadow: '0 1px 6px rgba(0,0,0,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <img src={LOGO} alt="TandaClick" style={{ height: 36, width: 'auto', objectFit: 'contain' }} />
          
        </div>
        <button onClick={onEntrar} style={{ background: C.primary, color: C.white, border: 'none', borderRadius: 10, padding: '8px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Entrar →</button>
      </nav>

      {/* Hero */}
      <section style={{ background: `linear-gradient(160deg, ${C.primaryLt} 0%, ${C.white} 60%)`, padding: '52px 20px 48px', textAlign: 'center', borderBottom: `1px solid ${C.gray100}` }}>
        <div style={{ display: 'inline-block', background: C.primaryLt, color: C.primary, borderRadius: 99, padding: '5px 16px', fontSize: 12, fontWeight: 700, marginBottom: 20, border: `1px solid ${C.primaryMd}` }}>✦ La tanda de siempre, ahora digital y segura</div>
        <h1 style={{ fontSize: 34, fontWeight: 900, color: C.text, lineHeight: 1.15, marginBottom: 16, letterSpacing: -0.5 }}>Tu tanda, ahora<br /><span style={{ color: C.primary }}>100% digital y segura</span></h1>
        <p style={{ fontSize: 15, color: C.textMd, maxWidth: 320, margin: '0 auto 32px', lineHeight: 1.7 }}>Organiza tandas con familia, amigos y compañeros. Sin Excel, sin desconfiar. Con comprobante de cada peso.</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 28, marginBottom: 36 }}>
          {[['🛡️', 'Sin riesgo', 'Depósito protegido'], ['⚡', '5 min', 'Para registrarte'], ['🔐', 'Confianza', 'Identidad verificada y score público']].map(([icon, n, l]) => (
            <div key={n} style={{ textAlign: 'center', maxWidth: 90 }}>
              <div style={{ fontSize: 20, marginBottom: 4 }}>{icon}</div>
              <div style={{ fontSize: 13, fontWeight: 900, color: C.primary, lineHeight: 1.2 }}>{n}</div>
              <div style={{ fontSize: 9, color: C.textLt, marginTop: 2, lineHeight: 1.3 }}>{l}</div>
            </div>
          ))}
        </div>
        <Btn onClick={onEntrar} style={{ maxWidth: 320, margin: '0 auto', padding: '15px 0', fontSize: 16, borderRadius: 14 }}>🚀 Crear mi cuenta gratis</Btn>
        <div style={{ fontSize: 12, color: C.textLt, marginTop: 12 }}>Identidad verificada · Reporte al Buró · SOFOM E.N.R.</div>
      </section>

      {/* Métodos de pago */}
      <section style={{ padding: '48px 20px', background: C.white }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: C.primary, letterSpacing: 1, textAlign: 'center', marginBottom: 8, textTransform: 'uppercase' }}>Métodos de pago</div>
        <h2 style={{ fontSize: 24, fontWeight: 800, color: C.text, textAlign: 'center', marginBottom: 8, letterSpacing: -0.3 }}>Paga y cobra<br />como tú quieras</h2>
        <p style={{ fontSize: 13, color: C.textMd, textAlign: 'center', marginBottom: 28, lineHeight: 1.6 }}>Con cuenta bancaria o sin ella, TandaClick tiene una opción para ti.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Card style={{ padding: '18px 16px' }}>
            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ fontSize: 32, flexShrink: 0 }}>🏦</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 4 }}>Transferencia SPEI</div>
                <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.6 }}>Deposita y cobra tu tanda directo desde tu banco. Validamos que el nombre del titular coincida para mayor seguridad.</div>
                <div style={{ marginTop: 8, display: 'inline-block', background: C.successLt, color: C.success, borderRadius: 99, padding: '3px 10px', fontSize: 11, fontWeight: 700 }}>✓ Disponible</div>
              </div>
            </div>
          </Card>
          <Card style={{ padding: '18px 16px' }}>
            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <div style={{ fontSize: 32, flexShrink: 0 }}>🏪</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 800, color: C.text, marginBottom: 4 }}>Pago y cobro en OXXO</div>
                <div style={{ fontSize: 12, color: C.textMd, lineHeight: 1.6 }}>Deposita tu tanda en cualquier OXXO con una referencia automática que llega a tu WhatsApp. ¿Sin cuenta bancaria? Cuando te toque cobrar te enviamos un código QR para canjear en efectivo.</div>
                <div style={{ marginTop: 8, display: 'inline-block', background: C.successLt, color: C.success, borderRadius: 99, padding: '3px 10px', fontSize: 11, fontWeight: 700 }}>✓ Disponible</div>
              </div>
            </div>
          </Card>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '48px 20px', background: C.gray50, borderTop: `1px solid ${C.gray200}` }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: C.primary, letterSpacing: 1, textAlign: 'center', marginBottom: 8, textTransform: 'uppercase' }}>Por qué TandaClick</div>
        <h2 style={{ fontSize: 24, fontWeight: 800, color: C.text, textAlign: 'center', marginBottom: 28 }}>La forma más inteligente<br />de hacer una tanda</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {[
            ['🔐', 'Verificado', 'INE + CURP + selfie. Cada peso con nombre, fecha y referencia.'],
            ['⚡', 'Adelanta tu tanda', '¿Necesitas el dinero antes de tu turno? Solo paga la comisión de adelanto.'],
            ['📊', 'Buró de Crédito', 'Pagos puntuales construyen tu historial crediticio. Los tardíos también se reportan.'],
            ['💬', 'Asistente 24/7', 'Tu agente de WhatsApp conoce tu tanda: fechas, montos y turnos.'],
            ['🏦', 'Acceso a crédito', 'Usuarios Oro+ acceden a créditos via TandaClick SOFOM E.N.R.'],
            ['📊', 'Tu dinero siempre visible', 'Cada semana ves quién pagó, quién debe y cuánto falta para tu turno. Sin llamadas, sin perseguir a nadie.'],
          ].map(([icon, title, desc]) => (
            <Card key={title} style={{ padding: '18px 14px' }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{icon}</div>
              <div style={{ fontSize: 13, fontWeight: 800, color: C.text, marginBottom: 6 }}>{title}</div>
              <div style={{ fontSize: 11, color: C.textMd, lineHeight: 1.6 }}>{desc}</div>
            </Card>
          ))}
        </div>
      </section>

      {/* Tabla Niveles */}
      <section style={{ padding: '48px 20px', background: C.white, borderTop: `1px solid ${C.gray200}` }}>
        <TablaNiveles />
      </section>

      {/* Cómo funciona */}
      <section style={{ padding: '48px 20px', background: C.gray50, borderTop: `1px solid ${C.gray200}` }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: C.primary, letterSpacing: 1, textAlign: 'center', marginBottom: 8, textTransform: 'uppercase' }}>Cómo funciona</div>
        <h2 style={{ fontSize: 24, fontWeight: 800, color: C.text, textAlign: 'center', marginBottom: 32 }}>Listo en 4 pasos</h2>
        {[['Regístrate en 5 min', 'Nombre, email, WhatsApp y contraseña. Elige tu método de pago y cobro.'], ['Encuentra tu tanda', 'Busca una tanda que se ajuste a tu monto y calendario, y únete en un click.'], ['Deposita en tu fecha', 'Por transferencia o OXXO. Sube tu comprobante en la app.'], ['Cobra tu tanda', 'En tu turno recibes tu tanda. Tu score sube y tus condiciones mejoran.']].map(([t, d], i) => (
          <div key={t} style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: i < 3 ? 24 : 0 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: C.primary, color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 16, flexShrink: 0 }}>{i + 1}</div>
            <div style={{ paddingTop: 8 }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 4 }}>{t}</div>
              <div style={{ fontSize: 13, color: C.textMd, lineHeight: 1.6 }}>{d}</div>
            </div>
          </div>
        ))}
      </section>

      {/* ── FAQs ── */}
      <section style={{ padding: '52px 20px 40px', background: '#F8FAFC', borderTop: '1px solid #E5E7EB' }}>
        <div style={{ fontSize: 12, fontWeight: 800, color: '#1A56DB', letterSpacing: 1, textAlign: 'center', marginBottom: 8, textTransform: 'uppercase' }}>Preguntas frecuentes</div>
        <div style={{ fontSize: 24, fontWeight: 900, color: '#1E293B', textAlign: 'center', marginBottom: 32, lineHeight: 1.3 }}>Resolvemos tus dudas</div>
        <FaqLista />
      </section>

      {/* CTA */}
      <section style={{ background: `linear-gradient(135deg, ${C.primary}, ${C.accent})`, padding: '52px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: 26, fontWeight: 900, color: C.white, marginBottom: 12 }}>¿Listo para empezar?</div>
        <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.85)', marginBottom: 32, lineHeight: 1.7 }}>Miles de mexicanos ya ahorran con TandaClick.<br />Tu dinero, siempre protegido.</div>
        <Btn onClick={onEntrar} variant="white" style={{ maxWidth: 300, margin: '0 auto', padding: '15px 0', fontSize: 15 }}>🤝 Crear mi cuenta — Es gratis</Btn>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 16 }}>Powered by TandaClick SOFOM E.N.R.</div>
      </section>

      <footer style={{ padding: '28px 20px 36px', background: C.gray800, textAlign: 'center' }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: C.white, marginBottom: 8 }}>TandaClick</div>
        <div style={{ fontSize: 12, color: C.gray400, lineHeight: 1.9, marginBottom: 16 }}>León, Guanajuato · México · contacto@tandaclick.com<br />Powered by TandaClick SOFOM E.N.R.</div>
        <div style={{ background: 'rgba(255,255,255,0.06)', borderRadius: 10, padding: '10px 14px', marginBottom: 16, border: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 11, color: C.gray400, lineHeight: 1.8 }}>Entidad supervisada por <strong style={{ color: C.white }}>CONDUSEF</strong><br />800 999 8080 · <span style={{ color: C.accent }}>www.condusef.gob.mx</span></div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 20 }}>
          <span onClick={onAviso} style={{ fontSize: 12, color: C.accent, cursor: 'pointer', textDecoration: 'underline' }}>Aviso de Privacidad</span>
          <span onClick={onTerminos} style={{ fontSize: 12, color: C.accent, cursor: 'pointer', textDecoration: 'underline' }}>Términos y Condiciones</span>
        </div>
      </footer>
    </div>
  );
}


export { Landing, AvisoPrivacidad, TerminosCondiciones, TablaNiveles };
